import {
  CanvasAttentionSettings,
  CanvasCommentSettings,
  CanvasDrawingSettings,
  CanvasElementType,
  CanvasEmojiSettings,
  CanvasFilterSettings,
  CanvasFrameSettings,
  CanvasPictureSettings,
  CanvasShapeSettings,
  CanvasStickyNoteSettings,
  CanvasTextSettings,
  CanvasWidgetSettings,
  CanvasFreeAttentionNodeSettings,
} from '@y42/json-schema';
import { getCanvasAttentionModel } from './canvas-attention.model';
import { getCanvasFreeAttentionNodeModel } from './canvas-free-attention-node.model';
import { getCanvasCommentModel } from './canvas-comment.model';
import { getCanvasDrawingModel } from './canvas-drawing.model';
import { getCanvasEmojiModel } from './canvas-emoji.model';
import { CanvasFilterUISettings, getCanvasFilterModel } from './canvas-filter.model';
import { getCanvasFrameModel } from './canvas-frame.model';
import { getCanvasPictureModel } from './canvas-picture.model';
import { getCanvasShapeModel } from './canvas-shape.model';
import { getCanvasStickyNoteModel } from './canvas-sticky-note.model';
import { getCanvasTextModel } from './canvas-text.model';
import { CanvasWidgetUISettings, getCanvasWidgetModel } from './canvas-widget.model';

export interface CanvasElementTypeToTypeSettings {
  [CanvasElementType.Widget]: CanvasWidgetSettings;
  [CanvasElementType.Text]: CanvasTextSettings;
  [CanvasElementType.Picture]: CanvasPictureSettings;
  [CanvasElementType.Shape]: CanvasShapeSettings;
  [CanvasElementType.StickyNote]: CanvasStickyNoteSettings;
  [CanvasElementType.Comment]: CanvasCommentSettings;
  [CanvasElementType.Attention]: CanvasAttentionSettings;
  [CanvasElementType.FreeAttentionNode]: CanvasFreeAttentionNodeSettings;
  [CanvasElementType.Emoji]: CanvasEmojiSettings;
  [CanvasElementType.Drawing]: CanvasDrawingSettings;
  [CanvasElementType.Filter]: CanvasFilterSettings;
  [CanvasElementType.Frame]: CanvasFrameSettings;
}

export interface CanvasElementTypeToUITypeSettings extends CanvasElementTypeToTypeSettings {
  [CanvasElementType.Widget]: CanvasWidgetUISettings;
  [CanvasElementType.Filter]: CanvasFilterUISettings;
}

export const canvasElementTypeToModelCreator = {
  [CanvasElementType.Widget]: getCanvasWidgetModel,
  [CanvasElementType.Text]: getCanvasTextModel,
  [CanvasElementType.Picture]: getCanvasPictureModel,
  [CanvasElementType.Shape]: getCanvasShapeModel,
  [CanvasElementType.StickyNote]: getCanvasStickyNoteModel,
  [CanvasElementType.Comment]: getCanvasCommentModel,
  [CanvasElementType.Attention]: getCanvasAttentionModel,
  [CanvasElementType.FreeAttentionNode]: getCanvasFreeAttentionNodeModel,
  [CanvasElementType.Emoji]: getCanvasEmojiModel,
  [CanvasElementType.Drawing]: getCanvasDrawingModel,
  [CanvasElementType.Filter]: getCanvasFilterModel,
  [CanvasElementType.Frame]: getCanvasFrameModel,
} as const;
